import { useQuery } from 'react-query';
import { SwissFarmersShowService } from '~/api/services/farmers/swissFarmersShow';
import { onError } from '~/utils/helpers';

const getSwissMilkSamplesData = (id: string, data?: any) => useQuery(
  `swiss-milk-samples-data-${id}`,
  () => SwissFarmersShowService.getSwissMilkSamplesData(id, data),
  {
    enabled: !!id,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getSwissMilkSamples = (id: string, data?: any) => useQuery(
  `swiss-milk-samples-${id}-${JSON.stringify(data)}`,
  () => SwissFarmersShowService.getSwissMilkSamples(id, data),
  {
    enabled: !!id,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getSwissMilkDeliveriesData = (id: string) => useQuery(
  `swiss-milk-deliveries-data-${id}`,
  () => SwissFarmersShowService.getSwissMilkDeliveriesData(id),
  {
    enabled: !!id,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

const getSwissMilkDeliveries = (id: string, data?: any) => useQuery(
  `swiss-milk-deliveries-${id}-${JSON.stringify(data)}`,
  () => SwissFarmersShowService.getSwissMilkDeliveries(id, data),
  {
    enabled: !!id,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => data.data
  }
)

export const SwissQuery = {
  getSwissMilkSamplesData,
  getSwissMilkSamples,
  getSwissMilkDeliveriesData,
  getSwissMilkDeliveries
}
